import _styled from '@emotion/styled/base';
import { spacing, text, size, motion, color, opacity } from '@hubble/tokens/web';
import { BaseButtonElement } from '../../Button/styles.js';

const sizeMap = {
  sm: {
    paddingLeft: spacing[4],
    paddingRight: spacing[12],
    fontSize: text.typesets.body.xsBold.fontSize,
    lineHeight: text.typesets.body.xsBold.lineHeight
  },
  md: {
    paddingLeft: spacing[8],
    paddingRight: spacing[16],
    fontSize: text.typesets.body.smBold.fontSize,
    lineHeight: text.typesets.body.smBold.lineHeight
  }
};
const VisualElementPickerStyles = _styled(BaseButtonElement, {
  target: "e10hryge0"
})(({
  theme,
  size: size$1
}) => ({
  background: theme.colorScheme.background.secondary,
  border: `1px solid ${theme.colorScheme.border.primary}`,
  color: theme.colorScheme.content.primary,
  gap: spacing[8],
  height: size.control[size$1],
  ...sizeMap[size$1],
  fontWeight: text.typesets.body.smBold.fontWeight,
  transition: `transform ${motion.duration.fast} ${motion.timing.easeInOut},
    background-color ${motion.duration.fast} ${motion.timing.easeInOut}`,
  width: 'fit-content',
  userSelect: 'none',
  '& span + span': {
    color: theme.colorScheme.content.secondary
  },
  ':hover': {
    border: `1px solid ${theme.colorScheme.border.secondary}`
  },
  ':active': {
    transform: 'scale(0.98)'
  },
  ':focus-visible': {
    boxShadow: `0 0 0 2px ${color.base.blue[300]}`
  },
  ':disabled': {
    '& > *:not(span)': {
      opacity: opacity.disabledGraphic
    },
    '& span': {
      color: theme.colorScheme.content.disabled
    }
  }
}));

export { VisualElementPickerStyles };
